<!-- Footer Start -->
 <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
<footer class="{{layout}}">
    <!-- Top Footer -->
    <div class="container">
        <div class="footer-top">
            <div class="footer-logo">
                <img [src]="logo" alt="logo">
            </div>
        </div>
    </div>
    <!-- Middle Footer -->
    <div class="footer-middle">
        <div class="container">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
                    <h5 class="widget-title">Informations</h5>
                    <ul>
                        <li> <a routerLink="/">Accueil</a> </li>
                        <li> <a routerLink="/menu-v1">Menu</a> </li>
                        <li> <a routerLink="/about">A propos</a> </li>
                        <li> <a routerLink="/locations">Localisation</a> </li>
                        <li> <a routerLink="/contact">Contactez-nous</a> </li>
                    </ul>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
                    <h5 class="widget-title">Top Items</h5>
                    <ul>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Pizzas'}">Pizzas</a></li>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Makloub'}">Makloub</a></li>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Sandwich'}">Sandwich</a></li>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Salades'}">Salades</a></li>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Poutine'}">Poutine</a></li>
                        <li><a routerLink="/menu-v1" [queryParams]="{category: 'Breuvages'}">Breuvages</a></li>
                    </ul>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 footer-widget">
                    <h5 class="widget-title">Nos réseaux sociaux</h5>
                    <ul class="social-media">
                        <li> 
                            <a href="https://www.facebook.com/RESTOPITA" class="facebook" target="_blank" rel="noopener noreferrer"> 
                                <i class="fa-brands fa-facebook"></i> 
                            </a> 
                        </li>
                        <li> 
                            <a href="https://www.instagram.com/restopita/" class="instagram" target="_blank"> 
                                <i class="fab fa-instagram"></i> <!-- Notez "fab" pas "fa-brands" -->
                            </a> 
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- Footer Bottom -->
    <div class="footer-bottom">
        <div class="container">
            <div class="footer-copyright">
                <p> Copyright &copy; 2025 <a href="#">Pita Resto</a> All Rights Reserved. </p>
                <a href="javascript:void(0);" class="back-to-top"id="backToTop" (click)="gotoTop()" (window:scroll)="ScrolltoTop()">retour en haut <i class="fas fa-chevron-up"></i> </a>
            </div>
        </div>
    </div>
</footer>
<!-- Footer End -->